import {SmallLoader} from '@kit';

import React from 'react';

import {useGlossaryItemQuery} from '../../../generated/types';
import {PageTools} from '../../../components/page-tools';
import {getApolloError} from '../../../components/utils';
import {EditHoc} from '../../../components/edit-hoc';
import {Markdown} from '../../../components/utils/md';
import type {GlossaryItem} from '../../../generated/types';
import {NotFoundSeo, isNotFoundError, useNotFound} from '../../../lib/seo';
import {GlossarySeo} from '../seo';
import {NotFound} from '../../../components/not-found';
import {CommentTargetType, Comments} from '../../../components/comments';

import dashboardCss from '@kit/sidebar/dashboard.module.css';
import pageCss from '../../../components/common.module.css';

type Props = {
	glossaryItemId: string;
	title: string;
};

export const GlossaryView: React.FC<Props> = ({glossaryItemId, title}) => {
	const {data, loading, error} = useGlossaryItemQuery({variables: {id: glossaryItemId}, ssr: true});
	const glossaryItem = data?.glossaryItem;
	const notFound = !loading && !glossaryItem && isNotFoundError(error);
	useNotFound(notFound);

	return (
		<article className={dashboardCss.readingWrapper}>
			{glossaryItem && <GlossarySeo item={glossaryItem as GlossaryItem} />}
			{notFound && <NotFoundSeo />}
			{/* при серверной отрисовке страница ещё не знает, какая запись выбрана, поэтому название берём из неё самой */}
			<PageTools />
			<h1 className={dashboardCss.mainTitle}>{glossaryItem?.title || title}</h1>
			<div className={dashboardCss.page}>
				{loading && (
					<div className={pageCss.fullSizeBlock}>
						<SmallLoader />
					</div>
				)}
				{notFound ? (
					<NotFound />
				) : (
					error && <div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>
				)}
				{glossaryItem && (
					<div>
						<EditHoc
							load={() => import('../edit-buttons').then((m) => m.EditGlossary)}
							editProps={{id: glossaryItem.id}}
						>
							<Markdown text={glossaryItem.description || ''} />
						</EditHoc>
					</div>
				)}
				{glossaryItem && <Comments targetType={CommentTargetType.Glossary} targetId={glossaryItemId} />}
			</div>
		</article>
	);
};
